module.exports = __webpack_public_path__ + "static/media/eyebag.523a072d.svg";